import { connect } from 'react-redux';
import { toggleAwardsModal, PAP_STEPS } from 'project/ducks/awards';
import { fetchProject, getProject } from 'project/ducks/project';
import { fetchAwarded as fetchAwardedCreatives, getAwarded as getAwardedCreatives }
  from 'project/ducks/creatives';
import { updateAwardsRequest } from 'pap/ducks/pricing';
import { fetchWrapupsIfNeeded } from 'project/ducks/wrapup';
import { PACKAGE_ITEMS } from 'pap/ducks/workflow';
import { getDetailedCost } from 'pap/utils';
import { PAP_VALIDATION_FUNCTIONS_MAP } from 'pap/components/common/input_fields';
import AwardsModal from 'project/components/awards_modal';

/* Re-use PAP award options step validation, just translating props appropriately. */
const validate = (value, allValues, props) => {
  if (!props) return undefined;

  return PAP_VALIDATION_FUNCTIONS_MAP.awards(
    value, allValues, { projectData: props.project, downgradeForbidden: true }
  );
};

const mapStateToProps = (state) => {
  const project = getProject(state);
  const form = state.form.AwardsModal;
  const formValues = form ? (form.values || {}) : {};
  const oldCost = getDetailedCost(project.features, project.award_rules, {});
  const newCost = getDetailedCost(project.features, project.award_rules, formValues);
  const upgradeCost = newCost.total - oldCost.total;
  const awardedCreatives = getAwardedCreatives(state, true);

  return {
    papSteps: PAP_STEPS,
    packageItems: PACKAGE_ITEMS,
    newAwards: newCost.items.filter(item => item.name === 'Award'),
    project,
    upgradeCost,
    validate,
    awardedCreatives,
  };
};

export default connect(mapStateToProps, {
  onClose: toggleAwardsModal,
  updateAwardsRequest,
  fetchProject,
  fetchAwardedCreatives,
  fetchWrapupsIfNeeded
})(AwardsModal);



// WEBPACK FOOTER //
// ./project/containers/awards_modal.js